// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Drawer_overlay__iqDyH","overlayShow":"Drawer_overlayShow__FYgW6","content":"Drawer_content__lPhg9","close":"Drawer_close__ziOpi","scrollable":"Drawer_scrollable__UdYSS"};